module.exports = "/_next/static/1st.png";